module.exports = __webpack_public_path__ + "static/fonts/fons_1.4abbfb4.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fons_1.otf
// module id = u5Zg
// module chunks = 1